<template>
  <div class="overlay-loading" v-show="isWaitingForServer"></div>
  <div class="jackpot-actions">
    <h2>Select Jackpot game</h2>
    <ul class="list-buttons">
      <li v-for="game in games" v-bind:key="game.id">
        <button
          class="button"
          @click.stop="chooseGame(game)"
          :class="
            chosenGame != null && game.id == chosenGame.id
              ? 'disabled'
              : 'enabled'
          "
        >
          {{ game.name }} - {{ formatPrice(game) }} SEK
        </button>
      </li>
    </ul>
    <div class="unfinished" v-if="unfinishedTickets.length > 0">
      <h2>Unfinished tickets</h2>
      <ul class="unfinished-list">
        <li
          v-for="ticket in unfinishedTickets"
          v-bind:key="ticket.correlationId"
        >
          ID {{ ticket.correlationId }}
          <span v-if="ticket.tickets[0].autoCompleteOn"
            >- AutoCompletes on:
            {{ $filters.formatDate(ticket.tickets[0].autoCompleteOn) }}</span
          >
          - <a href="#" @click.stop="finalizeTicket(ticket)">Finalize</a>
        </li>
      </ul>
    </div>
    <div class="ticket-buy" v-if="chosenGame != null">
      <button class="button" @click.stop="buy()">Buy ticket</button>
    </div>
    <div class="ticket-result" v-if="lastTicketResult">
      <h2>Ticket result</h2>
      <strong>Result:</strong> {{ lastTicketResult.winAmount }} SEK
    </div>
  </div>
</template>

<script>
import store from "../store.js";
import {
  updateBalance,
  getUnfinishedTickets,
  finalizeGameWithCorrelationId,
  getJackpotTicket,
} from "../api.js";
import { unifiedBuy } from "../utils/unifiedBuy.js";
import { formatPrice } from "../utils/gameHelper.js";

export default {
  name: "JackpotGame",
  props: {},
  mounted() {
    const cfg = store.clientConfig;
    const group = cfg && cfg["Jackpot"] ? cfg["Jackpot"] || [] : [];
    this.games = Array.isArray(group) ? group : [];
  },
  data() {
    return {
      isWaitingForServer: false,
      chosenGame: null,
      store: store,
      currentCorrelationId: "",
      currentStatus: "",
      unfinishedTickets: [],
      lastTicketResult: null,
      games: [],
    };
  },
  methods: {
    formatPrice,
    chooseGame(_game) {
      this.chosenGame = _game;
      this.checkUnfinishedTickets();
      this.lastTicketResult = null;
    },
    checkUnfinishedTickets() {
      getUnfinishedTickets(this.chosenGame.id)
        .then((data) => {
          //console.log('unfinishedTickets: ', data);
          this.unfinishedTickets = data;
        })
        .catch(() => {
          this.unfinishedTickets = null;
        });
    },
    buy() {
      unifiedBuy({
        game: this.chosenGame,
        buyOverrides: {}, // No overrides needed for Jackpot
        setLoading: (v) => {
          this.isWaitingForServer = v;
        },
        refreshTickets: () => this.checkUnfinishedTickets(),
        refreshBalance: () => updateBalance(),
        onSuccess: (data) => {
          // Optionellt: hantera data om det behövs
          console.log("buy", this.chosenGame, data);
        },
        onError: (err) => {
          // Optionellt: hantera fel
          console.error("Jackpot buy error", err);
        },
      });
    },
    async finalizeTicket(_ticket) {
      this.isWaitingForServer = true;

      finalizeGameWithCorrelationId(_ticket.correlationId).then((data) => {
        data.tickets.forEach(async (ticket) => {
          if (ticket.isWinner) {
            await getJackpotTicket(ticket.id).then((data) => {
              ticket.winAmount = data.winAmount;
            });
          } else {
            ticket.winAmount = 0;
          }
          this.lastTicketResult = ticket;
        });
        this.isWaitingForServer = false;
        this.checkUnfinishedTickets();
        updateBalance();
      });
    },
  },
};
</script>

<style scoped>
ul.list-buttons {
  list-style-type: none;
  padding: 0;
}
ul.list-buttons li {
  display: inline-block;
  margin: 0 10px 10px 0;
}
</style>
